import { baseThemeValues } from 'constants/common';

const baseButtonProps = {
  boxShadow: 'palette.transparent',
  fontFamily: baseThemeValues.inherit,
  fontSize: '18px',
  fontWeight: 700,
  outlineColor: 'palette.transparent',
  outlineWidth: '0px',
};

const basePrimaryProps = {
  ...baseButtonProps,
  borderRadius: '6px',
  borderWidth: '0px',
};

const baseOutlinedProps = {
  ...baseButtonProps,
  borderRadius: '6px',
  borderWidth: '1px',
};

const baseIconProps = {
  ...baseButtonProps,
  borderColor: 'palette.transparent',
  borderRadius: '30px',
  borderWidth: '0px',
};

const baseLinkProps = {
  bg: 'palette.transparent',
  borderColor: 'palette.transparent',
  borderRadius: '0px',
  borderWidth: '0px',
  boxShadow: 'palette.transparent',
  fontFamily: baseThemeValues.inherit,
  fontSize: '14px',
  fontWeight: 600,
  outlineColor: 'palette.transparent',
  outlineWidth: '0px',
};

export const buttonTheme = {
  danger: {
    base: {
      ...basePrimaryProps,
      bg: 'palette.error.60',
      text: 'palette.error.5',
    },
    baseProps: basePrimaryProps,
    disabled: {
      ...basePrimaryProps,
      bg: 'palette.error.50',
      text: 'palette.error.10',
    },
    focus: {
      ...basePrimaryProps,
      bg: 'palette.error.60',
      outlineColor: 'palette.error.30',
      outlineWidth: '4px',
      text: 'palette.error.5',
    },
    hover: {
      ...basePrimaryProps,
      bg: 'palette.error.70',
      text: 'palette.error.5',
    },
    pressed: {
      ...basePrimaryProps,
      bg: 'palette.error.80',
      text: 'palette.error.5',
    },
  },
  icon: {
    base: {
      ...baseIconProps,
      bg: 'palette.transparent',
      text: 'palette.tertiary.80',
    },
    baseProps: baseIconProps,
    disabled: {
      ...baseIconProps,
      bg: 'palette.transparent',
      text: 'palette.neutral.30',
    },
    focus: {
      ...baseIconProps,
      bg: 'palette.primary.20',
      text: 'palette.primary.99',
    },
    hover: {
      ...baseIconProps,
      bg: 'palette.tertiary.10',
      text: 'palette.tertiary.95',
    },
    pressed: {
      ...baseIconProps,
      bg: 'palette.tertiary.20',
      text: 'palette.tertiary.95',
    },
  },
  link: {
    base: {
      ...baseLinkProps,
      text: 'palette.tertiary.60',
    },
    baseProps: baseLinkProps,
    disabled: {
      ...baseLinkProps,
      text: 'palette.neutral.40',
    },
    focus: {
      ...baseLinkProps,
      text: 'palette.tertiary.40',
    },
    hover: {
      ...baseLinkProps,
      text: 'palette.tertiary.50',
    },
    pressed: {
      ...baseLinkProps,
      text: 'palette.tertiary.30',
    },
  },
  outlined: {
    base: {
      ...baseOutlinedProps,
      bg: 'palette.transparent',
      borderColor: 'palette.neutral.40',
      text: 'palette.neutral.40',
    },
    baseProps: baseOutlinedProps,
    disabled: {
      ...baseOutlinedProps,
      bg: 'palette.transparent',
      borderColor: 'palette.tertiary.20',
      text: 'palette.tertiary.20',
    },
    focus: {
      ...baseOutlinedProps,
      bg: 'palette.surface.5',
      borderColor: 'palette.neutral.90',
      outlineColor: 'palette.primary.80',
      text: 'palette.neutral.90',
    },
    hover: {
      ...baseOutlinedProps,
      bg: 'palette.transparent',
      borderColor: 'palette.neutral.90',
      text: 'palette.neutral.90',
    },
    pressed: {
      ...baseOutlinedProps,
      bg: 'palette.surface.5',
      borderColor: 'palette.neutral.50',
      text: 'palette.neutral.90',
    },
  },
  outlinedDanger: {
    base: {
      ...baseOutlinedProps,
      bg: 'palette.transparent',
      borderColor: 'palette.error.60',
      text: 'palette.error.60',
    },
    baseProps: baseOutlinedProps,
    disabled: {
      ...baseOutlinedProps,
      bg: 'palette.transparent',
      borderColor: 'palette.tertiary.20',
      text: 'palette.tertiary.20',
    },
    focus: {
      ...baseOutlinedProps,
      bg: 'palette.surface.3',
      borderColor: 'palette.error.60',
      outlineColor: 'palette.primary.80',
      text: 'palette.error.60',
    },
    hover: {
      ...baseOutlinedProps,
      bg: 'palette.transparent',
      borderColor: 'palette.error.70',
      text: 'palette.error.70',
    },
    pressed: {
      ...baseOutlinedProps,
      bg: 'palette.surface.3',
      borderColor: 'palette.error.80',
      text: 'palette.error.80',
    },
  },
  primary: {
    base: {
      ...basePrimaryProps,
      bg: 'palette.primary.20',
      text: 'palette.primary.99',
    },
    baseProps: basePrimaryProps,
    disabled: {
      ...basePrimaryProps,
      bg: 'palette.tertiary.20',
      text: 'palette.tertiary.40',
    },
    focus: {
      ...basePrimaryProps,
      bg: 'palette.primary.20',
      outlineColor: 'palette.primary.80',
      outlineWidth: '4px',
      text: 'palette.primary.99',
    },
    hover: {
      ...basePrimaryProps,
      bg: 'palette.primary.10',
      text: 'palette.primary.99',
    },
    pressed: {
      ...basePrimaryProps,
      bg: 'palette.primary.5',
      text: 'palette.primary.99',
    },
  },
  primaryIcon: {
    base: {
      ...baseIconProps,
      bg: 'palette.primary.20',
      text: 'palette.primary.99',
    },
    baseProps: baseIconProps,
    disabled: {
      ...baseIconProps,
      bg: 'palette.tertiary.20',
      text: 'palette.tertiary.40',
    },
    focus: {
      ...baseIconProps,
      bg: 'palette.primary.20',
      text: 'palette.primary.99',
    },
    hover: {
      ...baseIconProps,
      bg: 'palette.primary.10',
      text: 'palette.primary.99',
    },
    pressed: {
      ...baseIconProps,
      bg: 'palette.primary.5',
      text: 'palette.primary.99',
    },
  },
  transparentDanger: {
    base: {
      ...basePrimaryProps,
      bg: 'palette.transparent',
      text: 'palette.error.40',
    },
    baseProps: basePrimaryProps,
    disabled: {
      ...basePrimaryProps,
      bg: 'palette.transparent',
      text: 'palette.tertiary.40',
    },
    focus: {
      ...basePrimaryProps,
      bg: 'palette.transparent',
      text: 'palette.error.50',
    },
    hover: {
      ...basePrimaryProps,
      bg: 'palette.transparent',
      text: 'palette.error.50',
    },
    pressed: {
      ...basePrimaryProps,
      bg: 'palette.transparent',
      text: 'palette.error.40',
    },
  },
  transparentPrimary: {
    base: {
      ...basePrimaryProps,
      bg: 'palette.transparent',
      text: 'palette.tertiary.40',
    },
    baseProps: basePrimaryProps,
    disabled: {
      ...basePrimaryProps,
      bg: 'palette.transparent',
      text: 'palette.neutral.40',
    },
    focus: {
      ...basePrimaryProps,
      bg: 'palette.transparent',
      text: 'palette.tertiary.70',
    },
    hover: {
      ...basePrimaryProps,
      bg: 'palette.transparent',
      text: 'palette.tertiary.60',
    },
    pressed: {
      ...basePrimaryProps,
      bg: 'palette.transparent',
      text: 'palette.tertiary.70',
    },
  },
  transparentWarning: {
    base: {
      ...basePrimaryProps,
      bg: 'palette.transparent',
      text: 'palette.warning.50',
    },
    baseProps: basePrimaryProps,
    disabled: {
      ...basePrimaryProps,
      bg: 'palette.transparent',
      text: 'palette.tertiary.40',
    },
    focus: {
      ...basePrimaryProps,
      bg: 'palette.transparent',
      text: 'palette.warning.50',
    },
    hover: {
      ...basePrimaryProps,
      bg: 'palette.transparent',
      text: 'palette.warning.50',
    },
    pressed: {
      ...basePrimaryProps,
      bg: 'palette.transparent',
      text: 'palette.warning.40',
    },
  },
};
